import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const mission = {
  setup() {

    const container = document.querySelector(".c-mission__cc");
    const layers = document.querySelectorAll(".counter-bg .counter-bg");

    // 1. Gestione Movimento Orizzontale (Mouse X)
    window.addEventListener("mousemove", (e) => {
      const xPercent = (e.clientX / window.innerWidth) - 0.5;

      layers.forEach((layer) => {
        const parent = layer.parentElement;
        const maxMoveX = (parent.offsetWidth - layer.offsetWidth) / 2;

        gsap.to(layer, {
          x: xPercent * maxMoveX,
          duration: 0.4,
          ease: "power2.out",
          overwrite: "auto"
        });
      });
    });

    // 2. Gestione Movimento Verticale (Scroll Y)
    layers.forEach((layer) => {
      const parent = layer.parentElement;
      const maxMoveY = (parent.offsetHeight - layer.offsetHeight) / 2;

      gsap.to(layer, {
        y: -maxMoveY, // Si muove verso l'alto durante lo scroll
        ease: "none",
        scrollTrigger: {
          trigger: container,
          start: "top bottom",
          end: "bottom top",
          scrub: true, // Sincronizza con Lenis
        }
      });
    });
  },

  init() {
    this.setup();
  }
}

export default mission;
